export default __webpack_public_path__ + "static/media/redis.91eb321d.png";